const PRODUCT_FORM_ID_NAME = document.getElementById("product-form");

// SlideProduct
function mmSlideProduct() {
	var splideElemMain = document.querySelector("#main-slider");
	// SLIDER PRODUCT
	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "slide",
			pagination: false,
			arrows: false,
			perPage: 1,
			easing: "cubic-bezier(0.55, 0, 0.12, 1)",
			speed: 1000,
			breakpoints: {
				768: {
					padding: {
						right: 40,
					},
				},
			},
		});
		var bar = splideElemMain.querySelector(".my-slider-progress-bar");

		main.on("mounted move", function () {
			var end = main.Components.Controller.getEnd() + 1;
			var rate = Math.min((main.index + 1) / end, 1);
			bar.style.width = String(100 * rate) + "%";
		});
		main.mount();
		document.querySelectorAll(".mm-product-media-thumbnail-elem").forEach(function (elem) {
			elem.addEventListener("click", function (e) {
				main.go(parseInt(elem.dataset.index));
			});
		});
	}
}

// Reco Slider
function setUpRecosSplide() {
	var splideElemReco = document.querySelector("#RecoSlider");

	new Splide(splideElemReco, {
		type: "loop",
		arrows: false,
		pagination: false,
		gap: 10,
		drag: "free",
		snap: true,
		perPage: 1,
		margin: 0,
		breakpoints: {
			900: {
				destroy: true,
			},
		},
	}).mount();
}

// // Info Slider
// function setUpInfoSplide () {
//     var splideInfo = document.querySelector("#InfoSlider");

//     new Splide( splideInfo, {
//     type   : 'slide',
//         arrows: false,
//         pagination: true,
//         gap: 20,
//         perPage: 1,
//         margin: 0
//         }).mount();
//     }



class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest(".mm-product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.addLoaderToMedia();
			this.updateURL();
			this.variantFetch();
      initReductionTable();
		}
	}

	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	addLoaderToMedia() {
		document.querySelector(".main-product-slider").classList.add("mm-loading");
	}

	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	renderVariantInfo(html) {
		// this.updateElementsOuter("#product-form", html);
		this.updateElementsOuter(".mm-product-form-second-block", html);
		this.updateElementsOuter(".mm-product-form-recommendation", html);


		this.updateElementsOuter(".main-product-slider", html, document);
		this.updateElementsOuter(".main-product-thumbnail-slider", html, document);
		this.updateElementsOuter(".mm-product-form-component-price", html, document);
		mmSlideProduct();
		mmStartSplideProduct();
		setUpRecosSplide();
		assignConstants();
		initReductionTable();
	}

	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	updateElementsOuter(selector, html, target = this.container) {
		const destinations = target.querySelectorAll(selector);
		const sources = html.querySelectorAll(selector);

		destinations.forEach((destination, index) => {
			const source = sources[index];
			if (source) {
				destination.outerHTML = source.outerHTML;
			}
		});
	}
}
customElements.define("variant-selector", VariantSelector);

let CTA, CTA_PRICE_ELEM, CTA_PRICE, CTA_COMPARE_AT_PRICE_ELEM, CTA_COMPARE_AT_PRICE;
let CTA_PRICE_ELEM_MOBILE, CTA_COMPARE_AT_PRICE_ELEM_MOBILE;
let MAIN_PRICE_ELEM, MAIN_COMPARE_AT_PRICE_ELEM;

function assignConstants() {
	CTA = document.getElementById("mmProductCta");
	CTA_PRICE_ELEM = document.getElementById("mmProductCtaPrice");
	CTA_PRICE = parseInt(CTA_PRICE_ELEM.dataset.price);
	CTA_COMPARE_AT_PRICE_ELEM = document.getElementById("mmProductCtaCompareAtPrice");
	CTA_COMPARE_AT_PRICE = parseInt(CTA_COMPARE_AT_PRICE_ELEM.dataset.price);

	// CTA Mobile
	CTA_PRICE_ELEM_MOBILE = document.getElementById("mmProductCtaPriceMobile");
	CTA_COMPARE_AT_PRICE_ELEM_MOBILE = document.getElementById("mmProductCtaCompareAtPriceMobile");

	// Main Price
	MAIN_PRICE_ELEM = document.getElementById("mmProductMainPrice");
	MAIN_COMPARE_AT_PRICE_ELEM = document.getElementById("mmProductMainCompareAtPrice");
}

assignConstants();

// change qtty Product Card
function mmChangeQttyProductCard(delta, elem) {
	const productCard = elem.closest(".mm-product-card-recommendation");
	const input = productCard.querySelector(".mmProductCardQttyInput");
	const unitPrice = input.dataset.unitPrice;

	if (delta == "-1" && input.value == "0") {
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);
		input.value = newValue;
		productCard.dataset.totalPrice = newValue * unitPrice;
		addCrossSellPriceToCTA(newValue, unitPrice);
	}
}

function addCrossSellPriceToCTA(qtty, unitPrice) {
	// on recupere la qtty de cross-sell ainsi que son prix unitaire
	const crossSellTotalPrice = qtty * unitPrice;
	const mainProductQtty = document.getElementById("mm_product_form_qtty_selector").value;

	// dataset cross sell total = foreach sur product cards qui portent un dataset cross_sell_price
	const crossSellProductCards = document.querySelectorAll(".mm-product-card-recommendation");
	let allCrossSellPrice = 0;
	crossSellProductCards.forEach(function (crossSellProductCard) {
		allCrossSellPrice = allCrossSellPrice + parseInt(crossSellProductCard.dataset.totalPrice);
	});

  let totalPrice = ((parseInt(CTA_PRICE_ELEM.dataset.unitPrice) * mainProductQtty + allCrossSellPrice) / 100).toFixed(2);
  let comparePrice = parseInt(CTA_PRICE_ELEM.dataset.unitPrice) + allCrossSellPrice;
	CTA_PRICE_ELEM.dataset.allCrossSellPrice = comparePrice;
	CTA_PRICE_ELEM.innerText = totalPrice.replace(".", ",") + "€";

	CTA_COMPARE_AT_PRICE_ELEM.dataset.allCrossSellPrice = parseInt(CTA_COMPARE_AT_PRICE_ELEM.dataset.price) + allCrossSellPrice;

	CTA_COMPARE_AT_PRICE_ELEM.innerText = `${((parseInt(CTA_COMPARE_AT_PRICE_ELEM.dataset.price) * mainProductQtty + allCrossSellPrice) / 100).toFixed(2).replace(".", ",")}€`;

	CTA_PRICE_ELEM_MOBILE.dataset.allCrossSellPrice = comparePrice;
	CTA_PRICE_ELEM_MOBILE.innerText = `${totalPrice.replace(".", ",")}€`;

	CTA_COMPARE_AT_PRICE_ELEM_MOBILE.dataset.allCrossSellPrice = parseInt(CTA_COMPARE_AT_PRICE_ELEM.dataset.price) + allCrossSellPrice;
	CTA_COMPARE_AT_PRICE_ELEM_MOBILE.innerText = `${((parseInt(CTA_COMPARE_AT_PRICE_ELEM.dataset.price) * mainProductQtty + allCrossSellPrice) / 100).toFixed(2).replace(".", ",")}€`;

  //Update reduction table
  initReductionTable(totalPrice);
}

// change qtty
function mmChangeQtty(delta, inputId) {
	var input = document.getElementById(inputId);
	if (delta == "-1" && input.value == "1") {
	} else {
		var newValue = parseInt(input.value, 10) + parseInt(delta, 10);
		input.value = newValue;

		syncOtherSelector(newValue);
		updateMetersInfo(newValue);
		updatePrices(newValue);
		updateCrossSellQtty(newValue);
		updateCrossSellLitrage(newValue);
	}
}

function syncOtherSelector(qtty) {
	const deskSelector = document.getElementById("mm_product_form_qtty_selector");
	const mobileSelector = document.getElementById("mm_product_form_qtty_selector_mobile");
	deskSelector.value = qtty;
	mobileSelector.value = qtty;
}

function updateMetersInfo(qtty) {
	const metersInfoElems = document.querySelectorAll(".mm-count-meters");
	if (metersInfoElems) {
		metersInfoElems.forEach(function (metersInfoElem) {
			const metersForOne = metersInfoElem.dataset.metersForOne;

			const newMetersInfo = qtty * metersForOne;

			metersInfoElem.innerText = newMetersInfo.toFixed(1);
		});
	}
}

function updatePrices(qtty) {
	// dataset cross sell total = foreach sur product cards qui portent un dataset cross_sell_price
	const crossSellProductCards = document.querySelectorAll(".mm-product-card-recommendation");
	let allCrossSellPrice = 0;
	crossSellProductCards.forEach(function (crossSellProductCard) {
		allCrossSellPrice = allCrossSellPrice + parseInt(crossSellProductCard.dataset.totalPrice);
	});

	// Main CTA
	const CTA = document.getElementById("mmProductCta");
	const CTA_price_elem = document.getElementById("mmProductCtaPrice");
	const CTA_price = parseInt(CTA_price_elem.dataset.price);
	const CTA_compare_at_price_elem = document.getElementById("mmProductCtaCompareAtPrice");
	const CTA_compare_at_price = parseInt(CTA_compare_at_price_elem.dataset.price);
	// const qttyBreaksTargets = JSON.parse(CTA.dataset.qttyBreaksNb);
	// const qttyBreaksDiscounts = JSON.parse(CTA.dataset.qttyBreaksDiscounts);

	// let index = 0;
	// let discount = 0;
	// for (let qttyBreaksTarget of qttyBreaksTargets) {
	// 	if (qtty >= qttyBreaksTarget) {
	// 		discount = qttyBreaksDiscounts[index];
	// 		index++;
	// 	}
	// }

	// Calcul du montant de la remise
	// const discountAmount = (CTA_price * discount) / 100;

	// // Calcul du prix remisé
	// const discountedPrice = CTA_price - discountAmount;
	// CTA_price_elem.dataset.unitPrice = discountedPrice;

	CTA_PRICE_ELEM.dataset.allCrossSellPrice = parseInt(CTA_PRICE_ELEM.dataset.unitPrice) + allCrossSellPrice;
  let totalPrice = (parseInt(CTA_PRICE_ELEM.dataset.unitPrice) * qtty + allCrossSellPrice) / 100;
  let compareTotalPrice = (parseInt(CTA_COMPARE_AT_PRICE_ELEM.dataset.price) * qtty + allCrossSellPrice) / 100

	CTA_PRICE_ELEM.innerText = totalPrice.toFixed(2).replace(".", ",") + "€";

	CTA_COMPARE_AT_PRICE_ELEM.dataset.allCrossSellPrice = parseInt(CTA_COMPARE_AT_PRICE_ELEM.dataset.price) + allCrossSellPrice;
	CTA_COMPARE_AT_PRICE_ELEM.innerText = `${compareTotalPrice.toFixed(2).replace(".", ",")}€`;


	CTA_PRICE_ELEM_MOBILE.dataset.allCrossSellPrice = parseInt(CTA_PRICE_ELEM.dataset.unitPrice) + allCrossSellPrice;
	CTA_PRICE_ELEM_MOBILE.innerText = `${totalPrice.toFixed(2).replace(".", ",")}€`;

	CTA_COMPARE_AT_PRICE_ELEM_MOBILE.dataset.allCrossSellPrice = parseInt(CTA_COMPARE_AT_PRICE_ELEM.dataset.price) + allCrossSellPrice;
	CTA_COMPARE_AT_PRICE_ELEM_MOBILE.innerText = `${compareTotalPrice.toFixed(2).replace(".", ",")}€`;

	MAIN_PRICE_ELEM.innerText = `${(parseInt(CTA_PRICE_ELEM.dataset.unitPrice) / 100).toFixed(2).replace(".", ",")}€`;

	MAIN_COMPARE_AT_PRICE_ELEM.innerText = `${(parseInt(CTA_COMPARE_AT_PRICE_ELEM.dataset.price) / 100).toFixed(2).replace(".", ",")}€`;

	//Update reduction table
	initReductionTable(totalPrice);

	// if (discountAmount > 0) {
	// 	CTA_COMPARE_AT_PRICE_ELEM.style.display = "inline-block";
	// 	CTA_COMPARE_AT_PRICE_ELEM_MOBILE.style.display = "inline-block";
	// 	MAIN_COMPARE_AT_PRICE_ELEM.style.display = "inline-block";
	// } else {
	// 	CTA_COMPARE_AT_PRICE_ELEM.style.display = "none";
	// 	CTA_COMPARE_AT_PRICE_ELEM_MOBILE.style.display = "none";
	// 	MAIN_COMPARE_AT_PRICE_ELEM.style.display = "none";
	// }
}

function updateCrossSellQtty(qtty) {
	const qttyRecoElem = document.getElementById("mmQttyReco");
	if (qttyRecoElem) {
		qttyRecoElem.innerText = qtty;
	}
}

function updateCrossSellLitrage(qtty) {
	const crossSellCards = document.querySelectorAll(".mm-product-card-recommendation");

	crossSellCards.forEach(function (crossSellCard) {
		let variantLitrage = crossSellCard.dataset.litrageVariant;
		let recoProductLitrage = crossSellCard.dataset.litrageRecoProduct;
		let litrageInfoElem = crossSellCard.querySelector(".mm-reco-products-litrage");

		let totalSoilNeeded = qtty * variantLitrage;
		let bagsNeeded = Math.ceil(totalSoilNeeded / recoProductLitrage);

		litrageInfoElem.innerText = bagsNeeded;
	});
}



//Reduction table
function initReductionTable(ctaPrice = "") {
	const reductionTableContainer = document.querySelector(".mm-block-remise-content");

  if(reductionTableContainer) {
    
	const cartTotalPrice = parseInt(reductionTableContainer.dataset.cartTotalPrice, 10) / 100;

	const reductionStep1 = reductionTableContainer.querySelector(".mm-pf-reduc-step-1");
	const reductionStep2 = reductionTableContainer.querySelector(".mm-pf-reduc-step-2");
	const reductionStep3 = reductionTableContainer.querySelector(".mm-pf-reduc-step-3");

	const priceStep1 = parseInt(reductionStep1.dataset.stepPrice, 10);
	const priceStep2 = parseInt(reductionStep2.dataset.stepPrice, 10);
	const priceStep3 = parseInt(reductionStep3.dataset.stepPrice, 10);

	const progressBarContainer = reductionTableContainer.querySelector(".mm-cart-progress-bar-container");
	const progressBarStep1 = progressBarContainer.querySelector(".mm-pf-pb-step-1");
	const progressBarStep2 = progressBarContainer.querySelector(".mm-pf-pb-step-2");
	const progressBarStep3 = progressBarContainer.querySelector(".mm-pf-pb-step-3");

	let productAndUpsellPrice;
	if (ctaPrice == "") {
      const PRODUCT_PRICE_VALUE = parseInt(document.querySelector("#mmProductCtaPrice").dataset.price, 10);
      productAndUpsellPrice = PRODUCT_PRICE_VALUE / 100;
	} else {
      productAndUpsellPrice = parseInt(ctaPrice, 10);
    }

	let totalPriceReduction = cartTotalPrice + productAndUpsellPrice;

	let reductionFinal;

	let stepMax = priceStep3;

	// Comparaison avec les steps
	if (totalPriceReduction >= priceStep3) {
		// Appliquer la réduction pour le step 3

		reductionStep1.classList.add("active");
		reductionStep2.classList.add("active");
		reductionStep3.classList.add("active");

		progressBarStep1.classList.add("mm-cart-progress-bar-info-step-active");
		progressBarStep2.classList.add("mm-cart-progress-bar-info-step-active");
		progressBarStep3.classList.add("mm-cart-progress-bar-info-step-active");

		reductionFinal = reductionStep3.dataset.stepReduction;
	} else if (totalPriceReduction >= priceStep2) {
		// Appliquer la réduction pour le step 2

		console.log("active 2");

		reductionStep1.classList.add("active");
		reductionStep2.classList.add("active");
		reductionStep3.classList.remove("active");

		progressBarStep1.classList.add("mm-cart-progress-bar-info-step-active");
		progressBarStep2.classList.add("mm-cart-progress-bar-info-step-active");
		progressBarStep3.classList.remove("mm-cart-progress-bar-info-step-active");

		reductionFinal = reductionStep2.dataset.stepReduction;
	} else if (totalPriceReduction >= priceStep1) {
		// Appliquer la réduction pour le step 1

		reductionStep1.classList.add("active");
		reductionStep2.classList.remove("active");
		reductionStep3.classList.remove("active");

		progressBarStep1.classList.add("mm-cart-progress-bar-info-step-active");

		progressBarStep2.classList.remove("mm-cart-progress-bar-info-step-active");
		progressBarStep3.classList.remove("mm-cart-progress-bar-info-step-active");

		reductionFinal = reductionStep1.dataset.stepReduction;
	} else {
		reductionStep1.classList.remove("active");
		reductionStep2.classList.remove("active");
		reductionStep3.classList.remove("active");
		progressBarStep1.classList.remove("mm-cart-progress-bar-info-step-active");
		progressBarStep2.classList.remove("mm-cart-progress-bar-info-step-active");
		progressBarStep3.classList.remove("mm-cart-progress-bar-info-step-active");

		if (CTA_COMPARE_AT_PRICE <= CTA_PRICE) {
			CTA_COMPARE_AT_PRICE_ELEM.style.display = "none";
			CTA_COMPARE_AT_PRICE_ELEM_MOBILE.style.display = "none";
			MAIN_COMPARE_AT_PRICE_ELEM.style.display = "none";
		}
	}

	updateProgressBar(progressBarContainer, totalPriceReduction, stepMax);
	if (reductionFinal) {
		addReductionToTotalPriceCTA(reductionFinal, productAndUpsellPrice);
	}
  }

}


function updateProgressBar(progressBarContainer, totalPrice, stepMax) {

	const progressBar = progressBarContainer.querySelector(".mm-cart-progress-bar-inner");
	let progressBarWidth = (((totalPrice * 100) / stepMax) * 100) / 100;
	progressBar.style.width = progressBarWidth + "%";
}

function addReductionToTotalPriceCTA(reduction, price) {
  console.log('price', price)
	const CTA_compare_at_price_elem = parseInt(document.getElementById("mmProductCtaCompareAtPrice").dataset.allCrossSellPrice);
  const quantity = parseInt(document.getElementById("mm_product_form_qtty_selector").value);
  console.log(quantity, CTA_COMPARE_AT_PRICE_ELEM.dataset.allCrossSellPrice);
  const comparePriceCta = parseInt(CTA_compare_at_price_elem * quantity)

  /* Calcul prix après reduction */
  totalPriceWithReduction = price - (price * reduction) / 100;

  /* CTA Desktop*/
	CTA_PRICE_ELEM.innerText = totalPriceWithReduction.toFixed(2).replace(".", ",") + "€";
  CTA_COMPARE_AT_PRICE_ELEM.innerText = (comparePriceCta / 100).toFixed(2).replace(".", ",") + "€";

  /* CTA Mobile*/
	CTA_PRICE_ELEM_MOBILE.innerText = totalPriceWithReduction.toFixed(2).replace(".", ",") + "€";
	CTA_COMPARE_AT_PRICE_ELEM_MOBILE.innerText = (comparePriceCta / 100).toFixed(2).replace(".", ",") + "€";

	/* Main price / unité */
	mainPrice = parseInt(document.querySelector("#mmProductCtaPrice").dataset.price, 10);
	MAIN_PRICE_ELEM.innerText = ((mainPrice - (mainPrice * reduction) / 100) / 100).toFixed(2).replace(".", ",") + "€";
	MAIN_COMPARE_AT_PRICE_ELEM.innerText = (CTA_compare_at_price_elem / 100).toFixed(2).replace(".", ",") + "€";

  /* Show compare price */
	CTA_COMPARE_AT_PRICE_ELEM.style.display = "";
	CTA_COMPARE_AT_PRICE_ELEM_MOBILE.style.display = "inline-block";
	MAIN_COMPARE_AT_PRICE_ELEM.style.display = "inline-block";
}

document.addEventListener("DOMContentLoaded", () => {
	mmSlideProduct();
	setUpRecosSplide();
	initReductionTable();
});
